export const PAYMENT_STATUS = {
    SUCCESS:'success',
    FAILED:'failed',
    PENDING:'pending'
}